import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteFormValidationService } from 'app/_services/site-form-validation-service';

@Component({
  selector: 'site-form-table-modal',
  templateUrl: './site-form-table-modal.component.html',
})
export class SiteFormTableModalComponent implements OnInit {
  @Input() tableData: any[];
  @Input() originalAnswers: any[];

  answers: any[];

  public validationErrors: any[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private validationService: SiteFormValidationService,
  ) {}

  ngOnInit() {
    //deep copy answers to new object( to allow for Cancel)
    this.answers = JSON.parse(JSON.stringify(this.originalAnswers));
  }

  public closeModal() {
    this.activeModal.dismiss("form cancelled");
  }

  public deleteRow() {
    this.activeModal.dismiss({ delete: true });
  }

  public saveRow() {
    this.validationErrors = this.validationService.validateForm(this.answers, this.tableData);

    if (this.validationErrors.length) {
      return
    }
    this.activeModal.close(this.answers);
  }

  public getErrorByKey(key: number) {
    const error = this.validationErrors.find(item => item.key === key);
    return error ? true : false;
  }
  public setCheckboxValue(i, key, value) {
    if (!this.answers[i]) {
      this.answers[i] = [];
    }

    this.answers[i] = this.answers[i].filter(element => (element !== key));
    if (value) {
      this.answers[i].push(key);
    }
  }
}







